// extracted by mini-css-extract-plugin
export default {"Form":"Container_Form__NGYwq","Submit":"Container_Submit__Y0b4b"};